import { render, staticRenderFns } from "./qz-tray-print-settings.vue?vue&type=template&id=25f7560f&"
import script from "./qz-tray-print-settings.vue?vue&type=script&lang=js&"
export * from "./qz-tray-print-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports